import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Modal } from '../elements-modal/modal';
import { SearchModal } from './search-modal';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ActivityModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      subusetype: null
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.activityModalBody = this.activityModalBody.bind(this);
    this.closeBehavior = this.closeBehavior.bind(this);
  }

  componentDidMount () {
    if (this.props.closeDropdown) {
      analyticsIntegrations.locationModal(this.props.origin);
      this.props.closeDropdown();
    }
  }

  handleClickOutside () {
    this.setState({ isOpened: false });
  }

  activityModalBody () {
    const { activities } = this.props;
    const alphaActivites = _.sortBy(activities, 'dropdown');

    return (<div className="container-fluid">
      <div className="row">
        <div className="col-xs-12"></div>
        <div className="col-xs-12">
          <ul>
            { _.map(alphaActivites, (act, i) => {
              return (
                <div key={`activity_${i}`}className="col-xs-12 col-sm-6">
                  <li>
                    <a
                      onClick={this.handleListClick}
                      // data-value={m.nickname}
                      // data-geo={metro.map_boundaries}
                      data-name={act.dropdown}
                      data-id={act.id}
                      href="#"
                    >{act.dropdown}</a>
                  </li>
                </div>
              );
            })}
          </ul>
        </div>
      </div>
    </div>);
  }

  closeBehavior (e) {
    if (e) {
      $('#modal-container').modal('hide');
      return ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    }
    return ReactDOM.render(
      <SharedIntlProviderHOC>
        <SearchModal location={this.state.location} nickname={this.state.nickname}/>
      </SharedIntlProviderHOC>, document.getElementById('modal-container'));
  }

  handleListClick (e) {
    window.scrollTo(0, 0);
    if ('modal' !== this.props.origin) {
      if (!this.props.handleActivityClick) {
        return;
      } else {
        this.props.handleActivityClick(e);
        return this.closeBehavior(e);
      }
    }
    this.setState({
      subusetype: $(e.currentTarget).attr('data-name')
    }, () => {
      return this.closeBehavior();
    });
  }

  render () {
    return (<Modal
      show
      addCloseIcon
      modalType="standard"
      modalID="location-modal"
      modalSize={'sm-size'}
      body={ this.activityModalBody() }
      header={ this.props.intl.formatMessage({ id: 'boards.activity_modal.popular_activities', defaultMessage: 'Popular Activities' }) }
      footer={null}
      closeBehavior={this.closeBehavior}
    />);
  }
}

ActivityModal.propTypes = {
  closeDropdown: PropTypes.func,
  origin: PropTypes.string,
  activities: PropTypes.array
};

exports.ActivityModal = injectIntl(ActivityModal);
